import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import classNames from "classnames";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Menu from "@material-ui/core/Menu";
import { translate } from "react-i18next";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Avatar from "@material-ui/core/Avatar";
import Divider from "@material-ui/core/Divider";
import PersonIcon from "@material-ui/icons/Person";
import LogoutIcon from "@material-ui/icons/PowerSettingsNew";
import Typography from "@material-ui/core/Typography";
import NumberFormat from "react-number-format";// TODO: format number function

import { history } from "../_helpers";
import { gbConstants, THEME } from "../_constants";
import { images } from "../_assets";
import Notification from "./Notification"
const styles = theme => ({
    root: {
        flexGrow: 1
    },
    flex: {
        flex: 1
    },
    menuButton: {
        marginLeft: -12,
        marginRight: 20
    },
    list: {
        width: 250
    },
    margin: {
        margin: theme.spacing.unit
    },
    bootstrapRoot: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "none",
        textTransform: "none",
        fontSize: 15,
        width: 30,
        height: 30,
        borderRadius: 15,
        backgroundColor: THEME.COLOR.GREEN,
        borderColor: THEME.COLOR.GREEN,
        fontFamily: [
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"'
        ].join(",")
        // "&:hover": {
        //     backgroundColor: THEME.COLOR.BLUE,
        //     borderColor: "#0062cc"
        // },
        // "&:active": {
        //     boxShadow: "none",
        //     backgroundColor: "#0062cc",
        //     borderColor: "#005cbf"
        // },
        // "&:focus": {
        //     boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)"
        // }
    }
});

class AppMenu extends React.Component {
    state = {
        anchorNoti:null,
        anchorEl: null,
        left: false
    };

    handleChange = (event, checked) => {
        this.setState({ auth: checked });
    };

    handleMenu = event => {
        this.setState({ anchorEl: event.currentTarget });
    };
    
    toggleDrawer = (side, open) => () => {
        this.setState({
            [side]: open
        });
    };

    handleClose = () => {
        this.setState({ anchorEl: null });
    };
    
    handleClick = name => event => {
        history.push(name);
    };

    render() {
        const { t, classes, user, title,image } = this.props;
        const { anchorEl } = this.state;
        const open = Boolean(anchorEl);
        const self = this;

        function renderAccountMenu() {
            function formatNumber(value) {
                return (
                    <NumberFormat
                        value={value}
                        displayType={"text"}
                        thousandSeparator={"."}
                        decimalSeparator={","}
                        renderText={value => value}
                    />
                );
            }
            return (
                <Menu
                    id="menu-appbar"
                    anchorEl={anchorEl}
                    anchorOrigin={{
                        vertical: "top",
                        horizontal: "right"
                    }}
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "right"
                    }}
                    open={open}
                    onClose={self.handleClose}
                >
                    <ListItem
                        button
                        style={{
                            paddingTop: 20,
                            paddingBottom: 20,
                            paddingLeft: 16,
                            "&:hover": {
                                backgroundColor: "white"
                            },
                            "&:active": {
                                backgroundColor: "white"
                            },
                            "&:focus": {
                                backgroundColor: "white"
                            }
                        }}
                    >
                        <ListItemAvatar>
                            <Avatar
                                style={{
                                    backgroundColor: THEME.COLOR.GREEN
                                }}
                            >
                                {user.fullname.charAt(0).toUpperCase()}
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                            style={{ marginLeft: 8 }}
                            primary={
                                <Typography
                                    variant="title"
                                    style={{
                                        fontSize: 18
                                    }}
                                >
                                    {user.fullname}
                                </Typography>
                            }
                            secondary={
                                <Typography
                                    variant="subheading"
                                    style={{
                                        fontSize: 14,
                                        marginTop: 5
                                    }}
                                >
                                    {formatNumber(user.balance)} đ
                                </Typography>
                            }
                        />
                    </ListItem>
                    <Divider />
                    <List>
                        <ListItem
                            button
                            component={Link}
                            to={gbConstants.PATH_PROFILE}
                        >
                            <ListItemIcon>
                                <PersonIcon />
                            </ListItemIcon>
                            <ListItemText primary={t("Profile")} />
                        </ListItem>
                        <ListItem
                            button
                            component={Link}
                            to={gbConstants.PATH_LOGIN}
                        >
                            <ListItemIcon>
                                <LogoutIcon />
                            </ListItemIcon>
                            <ListItemText primary={t("Logout")} />
                        </ListItem>
                    </List>
                </Menu>
            );
        }

        return (
            <div className={classes.root}>
                <AppBar position="static" style={{ backgroundColor: "white" }}>
                    <Toolbar>
                        <img
                            src={images.adzLogo}
                            style={{ height: 30, width: 125 , cursor:"pointer"}}
                            alt="Logo"
                            onClick={() => history.push(gbConstants.PATH_ROOT)}
                        />

                        <div
                            className={classes.flex}
                            style={{
                                display: "flex",
                                justifyContent: "center"
                            }}
                        >
                            {title}
                        </div>

                        <div style={{position:"absolute",top:15,right:200}}>
                            {image}
                        </div>
                        
                        <div style={{marginRight:61,marginTop:7}}>
                            
                            <Notification />
                        </div>
                        <div>
                            <div
                                style={{cursor:"pointer"}}
                                className={classNames(classes.bootstrapRoot)}
                                onClick={this.handleMenu}
                            >
                                {user.fullname.charAt(0).toUpperCase()}
                            </div>
                            {renderAccountMenu()}
                        </div>
                    </Toolbar>
                </AppBar>
            </div>
        );
    }
}

AppMenu.propTypes = {
    classes: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    const { authentication } = state;
    const { user } = authentication;
    return {
        user
    };
}

const styleAppBar = withStyles(styles)(translate("translations")(AppMenu));
const connectedAppMenu = connect(mapStateToProps)(styleAppBar);
export { connectedAppMenu as AppMenu };



// WEBPACK FOOTER //
// ./src/AppMenu/AppMenu.jsx